export function numFormatter(number) {
  const num = parseFloat(number);
  if (num > 999 && num < 1000000) {
    return (num / 1000).toFixed(2) + "K"; // convert to K for number from > 1000 < 1 million
  } else if (num > 1000000) {
    return (num / 1000000).toFixed(2) + "M"; // convert to M for number from > 1 million
  } else if (num < 999) {
    return num; // if value < 1000, nothing to do
  }
}
export const getPercentage = (count, total) => {
  return ((parseFloat(count) / parseFloat(total)) * 100).toLocaleString(
    undefined,
    { minimumFractionDigits: 0, maximumFractionDigits: 2 }
  );
};
